import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';
import { CloudDetailsComponent } from './cloud-details/cloud-details.component';

const routes: Routes = [
  {
    path: 'cloud',
    component: CloudDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts cloud products',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'cloud products',
          },
        },
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CloudRoutingModule {}
